import { Pkg } from '@/api/pkg/types/Pkg'

export enum PkgReqStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}
export enum PkgReqStatusReasonEnum {
  UserCanceled = 'userCanceled',
  Canceled = 'canceled',
  FalseLabel = 'falseLabel',
  WasCorrected = 'wasCorrected',
  WasNotCorrected = 'wasNotCorrected',
  TooHeavy = 'tooHeavy',
  Fragile = 'fragile',
}
export interface StatusUpdate {
  status: PkgReqStatusEnum
  date: string
  reason?: PkgReqStatusReasonEnum
}
export enum PkgReqTypeEnum {
  PhotoRequest = 'photoRequest',
  ReturnRequest = 'returnRequest',
  ShrinkRequest = 'shrinkRequest',
  UniteRequest = 'uniteRequest',
  CountRequest = 'countRequest',
  MeasureRequest = 'measureRequest',
  PrintRequest = 'printRequest',
}
export interface PkgReq {
  id: string
  packageId: string
  reqType: PkgReqTypeEnum
  currentStatus: PkgReqStatusEnum
  statusUpdates: StatusUpdate[]
  warehouse: string
  customerId: string
  costumerEmail: string
  xlt: string
  warehouseLocation: string[]
  costumerFullName: string
  unit: string
  returnLabel?: string
  shrinkNotes?: string
  officeComment?: string
  userComment?: string
  feeUSD?: number
  shouldChargeFee?: boolean
  photo?: string
  photos?: string[]
  unitePackageIds?: string[]
  unitedPackageId?: string
  pkgs?: Pkg[]
  uniteReceiptUrl?: string
  shouldShrink?: boolean
  createdAt: string
  updatedAt?: string
  createdBy?: string
}
